<template>
  <div class="row">
    <div>
        <v-select
        class="col-lg-3"
        placeholder="Status Code"
        :options="statusCodeList"
        v-model="tableFilter['status']"
      ></v-select>
      <v-select
      class="col-lg-3"
        placeholder="Post"
        :options="postStatus"
        index="index" label="txt"
        v-model="tableFilter['post']"
      ></v-select>
    </div>
    <div class="col-lg-12 m-t-sm">
      <div class="title">
        <h4>{{ getIndexTableLength }} index results</h4>
      </div>
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Post</th>
          <th>#</th>
          <th>Status</th>
          <th>Url</th>
          <th>Title</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(res, i) in indexTable" :key="'index-' + i">
          <td>
            <i class="fa fa-check green" v-if="res.found"></i>
            <i class="fa fa-question orange" v-else></i>
          </td>
          <td>{{ res.rank_group || '' }}</td>
          <td>
            <span v-if="res.status">
              <span class="label label-primary" v-if="res.status === 200">{{ res.status }}</span>
              <span class="label label-danger" v-else>{{ res.status }}</span>
            </span>
            <span v-else-if="res.found">
              <span class="label label-success">200</span>
            </span>
            <span v-else>
              <span class="label label-warning">&nbsp; <i class="fa fa-question"></i> &nbsp;</span>
            </span>
          </td>
          <td>{{ res.url }} <a :href="res.url" target="_blank"><i class="fa fa-external-link"></i></a></td>
          <td>{{ res.title }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      index: [],
      postStatus: [
        {index: true, txt: 'Yes'},
        {index: false, txt: 'No'}
      ],
      tableFilter: {},
      statusCodeList: []
    }
  },
  watch: {
    $route (to, from) {
      this.loadIndex()
    }
  },
  mounted () {
    this.loadIndex()
  },
  computed: {
    ...mapGetters({
      site: 'getPbn'
    }),
    indexTable () {
      let newIndex = this.index
      if (this.tableFilter['post'] !== undefined && this.tableFilter['post'] !== null) {
        newIndex = newIndex.filter(i => i.found === this.tableFilter['post'])
      }
      if (this.tableFilter['status']) {
        newIndex = newIndex.filter(i => i.status === this.tableFilter['status'])
      }
      return newIndex
    },
    getIndexTableLength () {
      return this.indexTable.length
    }
  },
  methods: {
    loadIndex () {
      axios.get(`/pbn/site/${this.$route.params.domain}/index`)
        .then(r => {
          this.index = r.data.data
          this.statusCodeList = [...new Set(this.index.filter(i => i.status !== undefined).map(i => i.status))]
        })
        .catch(e => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Index.vue